import { PAGE_LOAD_ID_UPDATED } from './types';

export const updatePageLoadId = payload => dispatch =>  {
	dispatch({
		type: PAGE_LOAD_ID_UPDATED,
		payload: payload
	});
}
